import { buildWhatsAppUrl } from "@/utils/whatsapp";

export default function WhatsAppFloat({ productName, eventDate }) {
  const url = buildWhatsAppUrl(productName, eventDate);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-[calc(68px+env(safe-area-inset-bottom))] right-5 sm:bottom-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-semibold text-sm rounded-full shadow-lg px-4 py-3 transition-all duration-300 hover:scale-105 hover:shadow-xl group"
    >
      {/* WhatsApp SVG icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-5 h-5 flex-shrink-0 fill-white"
      >
        <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.738 5.474 2.027 7.785L0 32l8.418-2.006A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.769-1.847l-.485-.289-5.001 1.192 1.27-4.862-.316-.499A13.267 13.267 0 0 1 2.667 16C2.667 8.637 8.637 2.667 16 2.667S29.333 8.637 29.333 16 23.363 29.333 16 29.333zm7.293-9.907c-.4-.2-2.366-1.167-2.733-1.3-.367-.133-.634-.2-.9.2-.267.4-1.033 1.3-1.267 1.567-.233.267-.467.3-.867.1-.4-.2-1.687-.622-3.213-1.98-1.187-1.058-1.989-2.367-2.222-2.767-.233-.4-.025-.616.175-.816.18-.18.4-.467.6-.7.2-.233.267-.4.4-.667.133-.267.067-.5-.033-.7-.1-.2-.9-2.167-1.233-2.967-.325-.78-.656-.674-.9-.686l-.767-.013c-.267 0-.7.1-1.067.5s-1.4 1.367-1.4 3.333 1.433 3.867 1.633 4.133c.2.267 2.82 4.307 6.833 6.04.955.413 1.7.66 2.28.844.958.305 1.83.262 2.52.159.769-.115 2.366-.967 2.7-1.9.333-.933.333-1.733.233-1.9-.1-.167-.367-.267-.767-.467z" />
      </svg>
      <span className="hidden sm:inline">Chat With Us</span>
    </a>
  );
}